module.exports = __webpack_public_path__ + "static/img/kh-4.fe240dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-4.png
// module id = BNTQ
// module chunks = 4